import ExerciseEditor from './ExerciseEditor';

export default ExerciseEditor;
